<template>
  <b-modal
    id="modal-omnicloud-fr"
    @show="onShow"
    centered
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    scrollable
    size="lg"
  >
    <div>
      <b-row align-v="center" class="d-flex align-items-center">
        <b-col cols="6" class="mb-2">
                  <label class="text-capitalize">{{ $t("omnicloud_fr.face.watch_list") }}</label>
          <v-select
            v-model="watchlistFilter"
            :options="watchlistOptions"
            class="w-100"
            :multiple="false"
            :reduce="(val) => val.label"
            append-to-body
            :calculate-position="withPopper"
          />
        </b-col>
        <b-col cols="6" md="6" class="mb-md-0 mb-2">
          <b-form-group>
            <label class="text-capitalize">
              {{ $t("date.created_at") }}
            </label>
            <flat-pickr
              class="form-control"
              :config="{
                enableTime: true,
                dateFormat: 'Y-m-d H:i:s',
                time_24hr: true,
              }"
              v-model="startDate"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6" md="6" class="mb-md-0 mb-2">
          <b-form-group>
            <label class="text-capitalize">
              {{ $t("date.updated_at") }}
            </label>
            <flat-pickr
              class="form-control"
              :config="{
                enableTime: true,
                dateFormat: 'Y-m-d H:i:s',
                time_24hr: true,
              }"
              v-model="endDate"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer>
      <b-button
        size="sm"
        variant="secondary"
        class="text-capitalize"
        @click="$bvModal.hide('modal-omnicloud-fr')"
      >
        {{ $t("actions.cancel") }}
      </b-button>
      <b-button
        variant="info"
        size="sm"
        class="text-capitalize"
        @click="applyFilters"
      >
        {{ $t("actions.accept") }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    flatPickr,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      watchlistFilter: [],
      startDate: "",
      endDate: "",
    };
  },
  computed: {
    watchlistOptions() {
      return this.$store.getters['omnicloud_watch_list/getSelectedItems'];
    },
    filtersText() {
      const parts = [];
      if (this.watchlistFilter){
        parts.push(this.$t("omnicloud_fr.face.watch_list"));
      }
      if (this.startDate) {
        parts.push(this.$t("date.created_at"));
      }
      if (this.endDate){
        parts.push(this.$t("date.updated_at"));
      }
      return parts.length ? parts.join("<br>") : '';
    },
    countActiveFilters() {
      if (!this.filters) return 0;
      let count = 0;
      for (const key in this.filters) {
        const value = this.filters[key];
        if (Array.isArray(value)) {
          if (value.length > 0) count++;
        } else if (value !== null && value !== "" && value !== undefined) {
          count++;
        }
      }
      return count;
    },
  },
  methods: {
    async onShow() {
      await this.$store.dispatch("omnicloud_watch_list/getAll");

      if (this.filters && Object.keys(this.filters).length) {
        this.watchlistFilter = this.filters.watchlistFilter || "";
        this.startDate = this.filters.startDate || "";
        this.endDate = this.filters.endDate || "";
      } else {
        this.watchlistFilter = null;
        this.startDate = "";
        this.endDate = "";
      }
    },
    applyFilters() {
      const payload = this.updateFilters();
      this.$emit("filters-applied", payload);
      this.$bvModal.hide("modal-omnicloud-fr");
    },
    updateFilters() {
      const payload = {
        filters: {
          watchlistFilter: this.watchlistFilter,
          startDate: this.startDate,
          endDate: this.endDate,
        },
        filtersText: this.filtersText,
        filtersCount: this.countActiveFilters,
      };
      this.$emit("filters-selected", payload);
      return payload;
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler(newFilters, oldFilters) {
        if (JSON.stringify(newFilters) !== JSON.stringify(oldFilters)) {
          this.watchlistFilter = newFilters.watchlistFilter || "";
          this.startDate = newFilters.startDate || "";
          this.endDate = newFilters.endDate || "";
          this.updateFilters();
        }
      },
    },
  },
};
</script>